import { GET_COO_STATISTICS_URL } from '../../services/api/coo-statistics/CooStatisticsApi';
import legacy from '../../services/api/axios';

export const get_active_expired_wifi_subscribers = async (selectedYear, selectedCountry) => {
  const initialDateClicked = {
    from: `${selectedYear}-01-01`,
    to: `${selectedYear}-12-31`,
  };

  const initialExpirationState = {
    action: 'get_active_expired_wifi_subscribers',
    type: 'Expiration',
    ...initialDateClicked,
    country: `${selectedCountry}`,
  };

  // Create FormData instead of URLSearchParams
  const formData = new FormData();
  // Add each key-value pair to the FormData object
  Object.entries(initialExpirationState).forEach(([key, value]) => {
    formData.append(key, value);
  });

  try {
    const headers = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`,
    };

    // Send FormData directly without toString()
    const res = await legacy.post(`${GET_COO_STATISTICS_URL}`, formData, { headers });
    if (res.data) {
      return res.data;
    }
  } catch (error) {
    console.error(error);
  }
  // console.log(isLoading);
};
